import { render, staticRenderFns } from "./EnterPhonePage.vue?vue&type=template&id=4cf120b8&scoped=true"
import script from "./EnterPhonePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EnterPhonePage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EnterPhonePage.vue?vue&type=style&index=0&id=4cf120b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf120b8",
  null
  
)

export default component.exports